import { useState } from "react";
import { toast } from "sonner";
import { Send } from "lucide-react";

const WEB3FORMS_KEY = "55090c13-5bfe-417f-86ee-b1a5588ea109";
const EMPTY = { nome: "", email: "", mensagem: "" };

export default function ContactForm() {
  const [form, setForm] = useState(EMPTY);
  const [loading, setLoading] = useState(false);

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!form.nome || !form.email || !form.mensagem) {
      toast.error("Por favor preencha todos os campos.");
      return;
    }
    setLoading(true);
    try {
      const res = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          access_key: WEB3FORMS_KEY,
          subject: `Nova mensagem do website — ${form.nome}`,
          from_name: "CETIBER · Website",
          replyto: form.email,
          nome: form.nome,
          email: form.email,
          mensagem: form.mensagem,
          botcheck: "",
        }),
      });
      const data = await res.json();
      if (data.success) {
        toast.success("Mensagem enviada com sucesso. Entraremos em contacto brevemente.");
        setForm(EMPTY);
      } else {
        toast.error(data.message || "Não foi possível enviar. Tente novamente.");
      }
    } catch (err) {
      toast.error("Ocorreu um erro de rede. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="col-span-12 md:col-span-7">
      <div className="overline mb-4">Formulário</div>
      <h2 className="font-display font-bold uppercase text-3xl md:text-4xl text-[#0d4c7d] leading-tight tracking-tight mb-8">
        Envie-nos uma mensagem.
      </h2>
      <form onSubmit={onSubmit} data-testid="contact-form" className="space-y-5">
        {/* Honeypot field for bot protection */}
        <input type="checkbox" name="botcheck" className="hidden" style={{ display: "none" }} tabIndex="-1" autoComplete="off" />
        <div>
          <label className="overline block mb-2" htmlFor="nome">Nome</label>
          <input
            data-testid="contact-input-nome"
            id="nome" name="nome" type="text"
            className="cet-input" placeholder="O seu nome"
            value={form.nome} onChange={onChange}
            required minLength={2}
          />
        </div>
        <div>
          <label className="overline block mb-2" htmlFor="email">Email</label>
          <input
            data-testid="contact-input-email"
            id="email" name="email" type="email"
            className="cet-input" placeholder="exemplo@empresa.pt"
            value={form.email} onChange={onChange}
            required
          />
        </div>
        <div>
          <label className="overline block mb-2" htmlFor="mensagem">Mensagem</label>
          <textarea
            data-testid="contact-input-mensagem"
            id="mensagem" name="mensagem" rows={6}
            className="cet-input resize-none"
            placeholder="Descreva o seu pedido ou projeto…"
            value={form.mensagem} onChange={onChange}
            required minLength={5}
          />
        </div>
        <button
          data-testid="contact-submit-btn"
          type="submit" disabled={loading}
          className="btn-cet btn-primary w-full md:w-auto disabled:opacity-60 disabled:cursor-not-allowed"
        >
          {loading ? "A enviar…" : "Enviar Mensagem"} <Send size={16} />
        </button>
      </form>
    </div>
  );
}
